import React from 'react';
import { Instagram, Facebook, MapPin, Mail, Phone } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-brand-darker pt-24 pb-12 border-t border-brand-border/30" data-id="element-62">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12" data-id="element-63">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16 mb-20" data-id="element-64">
          {/* Brand */}
          <div className="lg:col-span-1" data-id="element-65">
            <div className="mb-6" data-id="element-66">
              <img src="https://cdn.magicpatterns.com/uploads/dnZYpy2HvqcZgbysSPT1d9/Dispel_gris.svg" alt="Dispel Your Tattoo" className="h-14 w-auto" data-id="element-67" />
            </div>
            <p className="text-brand-gray font-light text-sm leading-relaxed max-w-xs" data-id="element-68">
              Studio spécialisé en détatouage laser à Martigny. Technologie
              picoseconde & nanoseconde pour des résultats sûrs et efficaces.
            </p>
          </div>

          {/* Navigation */}
          <nav aria-label="Navigation du pied de page" data-id="element-69">
            <p className="text-brand-light font-bold uppercase tracking-widest text-sm mb-6" data-id="element-70">
              Navigation
            </p>
            <ul className="space-y-4 text-sm text-brand-gray font-light" data-id="element-71">
              <li data-id="element-72">
                <a href="#technology" className="hover:text-brand-light transition-colors" data-id="element-73">
                  Technologie laser
                </a>
              </li>
              <li data-id="element-74">
                <a href="#results" className="hover:text-brand-light transition-colors" data-id="element-75">
                  Avant / Après
                </a>
              </li>
              <li data-id="element-76">
                <a href="#pricing" className="hover:text-brand-light transition-colors" data-id="element-77">
                  Tarifs
                </a>
              </li>
              <li data-id="element-78">
                <a href="#faq" className="hover:text-brand-light transition-colors" data-id="element-79">
                  FAQ
                </a>
              </li>
              <li data-id="element-80">
                <a href="#blog" className="hover:text-brand-light transition-colors" data-id="element-81">
                  Blog
                </a>
              </li>
              <li data-id="element-82">
                <a href="#contact" className="hover:text-brand-light transition-colors" data-id="element-83">
                  Contact
                </a>
              </li>
            </ul>
          </nav>

          {/* Contact */}
          <div data-id="element-84">
            <p className="text-brand-light font-bold uppercase tracking-widest text-sm mb-6" data-id="element-85">
              Contact
            </p>
            <ul className="space-y-4 text-sm text-brand-gray font-light" data-id="element-86">
              <li className="flex items-start space-x-3" data-id="element-87">
                <MapPin size={18} className="shrink-0 mt-0.5 text-brand-light/50" data-id="element-88" />
                <span data-id="element-89">
                  Martigny, Suisse
                  <br data-id="element-90" />
                  (Adresse sur rendez-vous)
                </span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-91">
                <Mail size={18} className="shrink-0 text-brand-light/50" data-id="element-92" />
                <a href="mailto:hello@dispelyourtattoo.ch" className="hover:text-brand-light transition-colors" data-id="element-93">
                  hello@dispelyourtattoo.ch
                </a>
              </li>
              <li className="flex items-center space-x-3" data-id="element-94">
                <Phone size={18} className="shrink-0 text-brand-light/50" data-id="element-95" />
                <a href="tel:+41000000000" className="hover:text-brand-light transition-colors" data-id="element-96">
                  +41 00 000 00 00
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div data-id="element-97">
            <p className="text-brand-light font-bold uppercase tracking-widest text-sm mb-6" data-id="element-98">
              Réseaux
            </p>
            <div className="flex space-x-4" data-id="element-99">
              <a href="#" className="w-10 h-10 rounded-full border border-brand-border flex items-center justify-center text-brand-gray hover:text-brand-light hover:border-brand-light transition-all duration-300" data-id="element-100">
                <Instagram size={18} data-id="element-101" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-brand-border flex items-center justify-center text-brand-gray hover:text-brand-light hover:border-brand-light transition-all duration-300" data-id="element-102">
                <Facebook size={18} data-id="element-103" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-brand-border flex items-center justify-center text-brand-gray hover:text-brand-light hover:border-brand-light transition-all duration-300 font-bold italic text-sm" data-id="element-104">
                Tk
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-brand-border/30 flex flex-col md:flex-row items-center justify-between text-xs text-brand-gray/60 font-light" data-id="element-105">
          <p data-id="element-106">
            &copy; {new Date().getFullYear()} Dispel Your Tattoo. Tous droits
            réservés.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-107">
            <a href="#" className="hover:text-brand-gray transition-colors" data-id="element-108">
              Mentions légales
            </a>
            <a href="#" className="hover:text-brand-gray transition-colors" data-id="element-109">
              Politique de confidentialité
            </a>
            <a href="#" className="hover:text-brand-gray transition-colors" data-id="element-110">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>;
};